import { render, staticRenderFns } from "./OrganizationalChartForm.vue?vue&type=template&id=55843d32&"
import script from "./OrganizationalChartForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationalChartForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports